module.exports = __webpack_public_path__ + "img/FORMAGE.02de6875.png";